import { FunctionComponent, type JSX, ReactNode, Suspense } from 'react';

import { Loading } from './loading.component';

export function LazyLoad(Component: FunctionComponent, fallback?: ReactNode) {
  const LoadableComponent = function LoadableComponent(props: JSX.IntrinsicAttributes) {
    return (
      <Suspense fallback={fallback ?? <Loading />}>
        <Component {...props} />
      </Suspense>
    );
  };

  return LoadableComponent;
}
